// Application configuration
const rawUrl = import.meta.env.VITE_API_URL || '';

// Normalize: ensure trailing slash so axios resolves relative paths correctly.
// If no env var is set, fall back to same-origin (works when frontend & backend share a domain via nginx).
const apiUrl = rawUrl
  ? rawUrl.replace(/\/+$/, '') + '/'
  : window.location.origin + '/';

const config = { apiUrl };

export default config;
